export const TYPE_VALUE_FILTERS = {
    SELECT: 'select',
    SELECT_OBJECT: 'select_object',
    TIMESPAN: 'timespan',
    INPUT: 'input'
}